import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import UsersTable from "./UsersTable";
import GameHistory from "./GameHistory";
import Orders from "./Orders";
import Withdrawals from "./Withdrawals";
import DailyStatsPage from "./DailyStatsPage";
import ManageCards from "./ManageCards";
import { parseJWT } from "../../utils/jwtUtils";

export default function AdminDashboard() {
  const navigate = useNavigate();

  // ✅ SAFE parsing
  const stored = localStorage.getItem("userInfo");
  const parsed = stored ? JSON.parse(stored) : null;

  const token = parsed?.token;
  const userInfo = token ? parseJWT(token) : null;

  const [activePage, setActivePage] = useState("users");
  const [isOpen, setIsOpen] = useState(false);

  // ✅ ADD guard state (prevents UI flicker)
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    if (!token || !userInfo) {
      navigate("/", { replace: true });
      return;
    }

    const isAdmin =
      userInfo.role === "admin" || userInfo.role === "super_admin";

    if (!isAdmin) {
      navigate("/", { replace: true });
      return;
    }

    // ✅ only allow render if admin
    setAuthorized(true);
  }, [token, userInfo, navigate]);

  // ✅ BLOCK render until verified
  if (!authorized) {
    return null; // or loader
  }

  const renderPage = () => {
    switch (activePage) {
      case "users":
        return <UsersTable />;
      case "history":
        return <GameHistory />;
      case "orders":
        return <Orders />;
      case "withdrawals":
        return <Withdrawals />;
      case "daily":
        return <DailyStatsPage />;
      case "cards":
        return <ManageCards />;
      default:
        return <UsersTable />;
    }
  };

  const handlePlayNow = () => {
    navigate("/");
  };

  return (
    <div className="flex min-h-screen bg-gradient-to-b from-black to-blue-900 text-white">
      {/* mobile hamburger */}
      <button
        className="md:hidden fixed top-4 right-4 z-50 bg-blue-700 px-3 py-2 rounded"
        onClick={() => setIsOpen(true)}
      >
        ☰
      </button>

      <Sidebar
        activePage={activePage}
        setActivePage={setActivePage}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        onPlayNow={handlePlayNow}
      />

      <div className="flex-1 p-2 overflow-y-auto">{renderPage()}</div>
    </div>
  );
}
